import type { SagaReturnType } from 'redux-saga/effects';
import { all, put, select, takeLatest } from 'redux-saga/effects';

import { api } from 'src/api';
import { clientStorage } from 'src/api/storage';
import { logger } from 'src/error';

import { confirmClientAction } from 'src/store/client/actions';

import { getIsHotelOnly } from 'src/store/view/selectors';

import {
  deleteSavedTouristFailAction,
  deleteSavedTouristSuccessAction,
} from './slice';
import type { deleteSavedTouristAction } from './slice';

import {
  goToClientAction,
  goToClientDataAction,
  onClientClickAction,
  scrollToTouristsAction,
} from '../actions/view';
import { fetchSavedTourists } from '../actions/tourists';

import { DELETE_SAVED_TOURIST } from './constants';

/**
 * Обрабатывает сабмит данных клиента
 * 1. Скроллит к туристам
 */
function* handleConfirmClient() {
  yield put(scrollToTouristsAction());
  yield put(fetchSavedTourists());
}

function* handleDeleteTourist({
  payload,
}: ReturnType<typeof deleteSavedTouristAction>) {
  try {
    const authToken = clientStorage.getAuthToken();
    if (!authToken) {
      return;
    }

    const response = yield api.deleteClientTourists({
      auth_token: authToken,
      id: payload.id,
    });

    if (!response?.success) {
      yield put(deleteSavedTouristFailAction(payload.id));
      throw new Error(response.error);
    } else {
      yield put(deleteSavedTouristSuccessAction(payload.id));
    }
  } catch (e) {
    yield put(deleteSavedTouristFailAction(payload.id));
    logger(e as Error, 'handleDeleteClient: Failed to delete tourist');
  }
}

function* handleClientClick() {
  const isHotelOnly: SagaReturnType<typeof getIsHotelOnly> = yield select(
    getIsHotelOnly,
  );
  if (isHotelOnly) {
    yield put(goToClientDataAction());
  } else {
    yield put(goToClientAction());
  }
}

export default function* clientSaga() {
  yield all([takeLatest(confirmClientAction, handleConfirmClient)]);
  yield takeLatest(DELETE_SAVED_TOURIST, handleDeleteTourist);
  yield takeLatest(onClientClickAction.type, handleClientClick);
}
